import { Stack, Typography } from "@mui/material";
import { BaseModuleSubtype } from "../../../../../../types/actionModule/subtypes/subtype";
import { useTranslation } from "react-i18next";
import DefaultIcon from "../../../../../../components/common/DefaultIcon";
import { Check, CloseOutlined } from "@mui/icons-material";
import dayjs from "dayjs";
import { SurveyAppointmentSubtypeDataModel, EventWithAnswer, SurveyEventAnswer } from "../../../../../../types/actionModule/subtypes/surveyAppointmentSubtype";

interface Props {
    subtype: BaseModuleSubtype;
    subtypeData: SurveyAppointmentSubtypeDataModel;
}

export default function SurveyAppointmentSubtypeDetails(props: Props) {
    const { t } = useTranslation();

    if (props.subtypeData.noEventViable) {
        return <Typography sx={{ textOverflow: "ellipsis" }}>{t("incentivationPage.surveyAppointment.noEventSelected")}</Typography>
    }

    return <Stack direction="column" sx={{ gap: 1 }}>
        {props.subtypeData.eventAnswers.map(e => <EventAnswer event={e} />)}
    </Stack>
}

interface EventAnswerProps {
    event: EventWithAnswer;
}

const formatDateTime = (value: string) =>
    dayjs(value).format("DD.MM.YYYY HH:mm [Uhr]");

function EventAnswer(props: EventAnswerProps) {
    return <Stack direction="row" sx={{ alignItems: "center", gap: 2 }}>
        <DefaultIcon
            iconName={props.event.event.iconName}
            colorHex={props.event.event.colorHex}
            iconUrl={props.event.event.iconUrl}
        />
        <Stack direction="column">
            <Typography variant="body1">{props.event.event.title}</Typography>
            <Typography variant="caption">{formatDateTime(props.event.event.startDate)}</Typography>
            {
                props.event.event.startDate !== props.event.event.endDate &&
                <Typography variant="caption">{formatDateTime(props.event.event.endDate)}</Typography>
            }
        </Stack>
        {props.event.answer === SurveyEventAnswer.Accepted && <Check />}
        {props.event.answer === SurveyEventAnswer.Declined && <CloseOutlined />}
    </Stack>
}